/* eslint-env browser, jquery */

'use strict';

const trackingHubAdd = require('./tracking_hub_add');
const FetchHandler = require('./FetchHandler');
const UgcPhotosModel = require('./UgcPhotosModel');

const HELPFUL = 'like';
const NOT_HELPFUL = 'dislike';
const GALLERY_MODAL_IMAGE_COUNT = 20;
const GALLERY_MODAL_IMAGE_COUNT_INIT = GALLERY_MODAL_IMAGE_COUNT * 2;

const handleUnfilledAbstractMethod = methodName => {
  if (process.env.NODE_ENV === 'development') {
    throw new Error(`${methodName} hasnt been implemented`);
  }
};

class UgcPhotosAbstract {
  constructor(modalSelector, inlineSelector, gallerySelectors) {
    this.model = new UgcPhotosModel();

    this.$modal = $(modalSelector);
    this.gallerySelectors = gallerySelectors;
    $(inlineSelector).on('click', 'li', this.onImageClick.bind(this));

    this.setupReportModal();

    this.$inlineOpenGalleryLink = $(gallerySelectors.galleryLink);
    const $galleryModal = $(gallerySelectors.galleryModal);

    this.galleryModal = {
      $el: $galleryModal,
      $section: $galleryModal.find('.image-gallery'),
      $imageList: $galleryModal.find('ul'),
      $loader: $galleryModal.find('.loader'),
      $closeIcon: $galleryModal.find('.close-modal'),
    };

    this.fetchingGallery = false;
    this.pagination = {};
    this.currentCount = 0;
    this.fetchGalleryImageUrls(0, GALLERY_MODAL_IMAGE_COUNT_INIT, true);

    this.HELPFUL_ACTIVE_CLASSES = '';

    const baseOpts = {
      body: {
        merchantId: this.model.get('merchantUuid'),
      },
      credentials: 'include',
      method: 'post',
    };
    this.helpfulFetchHandler = new FetchHandler({
      successHandlers: [this.onHelpfulSuccess.bind(this)],
      errorHandlers: [this.onAjaxError.bind(this, 'helpful', false)],
      requestOpts: baseOpts,
      url: this.model.get('helpfulUrl'),
    });

    this.reportFetchHandler = new FetchHandler({
      successHandlers: [this.onReportSuccess.bind(this)],
      errorHandlers: [this.onAjaxError.bind(this, 'report', false)],
      requestOpts: baseOpts,
      url: this.model.get('reportUrl'),
    });
  }

  /* eslint-disable class-methods-use-this */
  setupReportModal() {
    /* defaults are needed for abstract class tests */
    this.reportModal = {
      $textarea: $('#ugc-report-photo-modal textarea'),
      $reasons: $('#ugc-report-photo-modal #ugc-photo-report-dropdown'),
    };
    handleUnfilledAbstractMethod('setupReportModal');
  }

  onReportTextareaChange() {
    handleUnfilledAbstractMethod('onReportTextareaChange');
  }

  onImageClick() {
    handleUnfilledAbstractMethod('onImageClick');
  }

  getReportModalReason() {
    handleUnfilledAbstractMethod('getReportModalReason');
  }

  openGalleryViewModal() {
    handleUnfilledAbstractMethod('openGalleryViewModal');
  }

  changeReportReason() {
    handleUnfilledAbstractMethod('changeReportReason');
  }

  openReportModal() {
    handleUnfilledAbstractMethod('openReportModal');
  }

  onReportSuccess() {
    handleUnfilledAbstractMethod('onReportSuccess');
  }

  onAjaxError() {
    handleUnfilledAbstractMethod('onAjaxError');
  }

  openNotificationModal() {
    handleUnfilledAbstractMethod('openNotificationModal');
  }
  /* eslint-enable */

  debounced(fun, wait = 200, immediate = false) {
    return this._debounce(fun, wait, immediate).bind(this);
  }

  _debounce(func, wait, immediate) {
    let timeout;
    return (...args) => {
      const context = this;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  onGalleryScroll(scrollPosition) {
    // start fetching just before we reach the last row of images
    const height =
      this.galleryModal.$imageList.height() -
      this.galleryModal.$imageList.find('li img').height();
    if (scrollPosition >= height && this.currentCount < this.pagination.count) {
      this.fetchGalleryImageUrls(this.currentCount);
    }
  }

  fetchGalleryImageUrls(
    offset = 0,
    limit = GALLERY_MODAL_IMAGE_COUNT,
    fetchReasons = false
  ) {
    if (
      !this.fetchingGallery &&
      (this.pagination.count === undefined || this.pagination.count > offset)
    ) {
      this.fetchingGallery = true;
      const url = `${this.model.get(
        'fetchUrl'
      )}&limit=${limit}&offset=${offset}&fetchReasons=${fetchReasons}`;
      this.galleryModal.$loader.addClass('show-loader');

      $.ajax({
        method: 'GET',
        dataType: 'json',
        url,
        success: data =>
          this.onFetchGalleryImageUrlsSuccess(data, fetchReasons, limit),
        complete: () => {
          this.fetchingGallery = false;
          if (this.currentCount >= this.pagination.count) {
            this.galleryModal.$loader.addClass('hide-loader');
          }
          this.galleryModal.$loader.removeClass('show-loader');
        },
      });
    }
  }

  onFetchGalleryImageUrlsSuccess(data, fetchReasons, limit) {
    if (!data || !Object.keys(data).length) {
      return;
    }

    this.currentCount += limit;
    this.addToImageData(data, limit);
    if (this.pagination.offset === 0) {
      this.initFillGalleryViewModal();
      this.$inlineOpenGalleryLink.on(
        'click',
        this.openGalleryViewModal.bind(this)
      );
    } else {
      this.appendGalleryViewModal();
    }

    if (fetchReasons) {
      this.setReportingReasons(data.reportReasonsHtml);
    }
  }

  addToImageData({ pagination = null, imagesByUuid = {}, ids = [] }) {
    this.pagination = pagination;
    this.model.addImages(imagesByUuid, ids);
  }

  setReportingReasons(reportReasonsHtml) {
    this.reportModal.$reasons.append(reportReasonsHtml);
    this.$modal.find('.report-link').show();
    const openReportModalOnLoad = this.model.get('openReportModalOnLoad');
    if (openReportModalOnLoad) {
      if (
        openReportModalOnLoad.reportUuid ===
          this.model.get('otherReasonUuid') &&
        window.sessionStorage
      ) {
        this.reportModal.$textarea.val(
          window.sessionStorage.getItem('ugcPhotos.reportOtherReasonText')
        );
        window.sessionStorage.removeItem('ugcPhotos.reportOtherReasonText');
        this.onReportTextareaChange();
      }
      this.changeReportReason(openReportModalOnLoad.reportUuid);
    }
  }

  redirectToLogin(from = null, event) {
    let returnTo = window.location.origin + window.location.pathname;
    let params;

    if (from === 'helpful') {
      params = `helpful=true&imageUuid=${this.$modal.attr('data-active-id')}`;
    } else {
      params = `reportPhoto=true&imageUuid=${this.$modal.attr(
        'data-active-id'
      )}&reportUuid=${this.getReportModalReason(event)}`;
    }

    if (window.location.search) {
      returnTo += `${window.location.search}&`;
    } else {
      returnTo += '?';
    }

    returnTo += params;
    window.location.assign(
      `${this.model.get('loginUrlBase')}?return_to=${encodeURIComponent(
        returnTo
      )}`
    );
  }

  saveTextInLocalStorage(reasonText) {
    if (!window.sessionStorage) {
      return;
    }
    window.sessionStorage.setItem(
      'ugcPhotos.reportOtherReasonText',
      reasonText
    );
  }

  onReportSubmit(event) {
    event.preventDefault();
    const reasonId = this.getReportModalReason(event);

    const infringingContent = this.model.get('infringingContent');
    if (reasonId === infringingContent.uuid) {
      window.open(window.location.origin + infringingContent.url);
      return;
    }

    const isOtherReason = reasonId === this.model.get('otherReasonUuid');
    const reasonText = isOtherReason
      ? this.reportModal.$textarea.val()
      : undefined;

    if (!this.model.isLoggedIn()) {
      if (isOtherReason) {
        this.saveTextInLocalStorage(reasonText);
      }
      this.redirectToLogin('report', event);
      return;
    }

    return this.reportFetchHandler.send({
      imageId: this.$modal.attr('data-active-id'),
      reasonId,
      reasonText,
    });
  }

  meetsMinimumTextareaLength() {
    return (
      this.reportModal.$textarea.val().length >
      this.model.get('minimumReportTextLength')
    );
  }

  initFillGalleryViewModal() {
    const galleryHtml = this.galleryTemplate(this.model.ids());
    this.galleryModal.$imageList.html(galleryHtml);
    this.galleryModal.$imageList.on(
      'click',
      'li',
      this.onImageClick.bind(this)
    );
  }

  appendGalleryViewModal() {
    const currentIds = this.model.ids();
    const ids = currentIds.slice(this.currentCount - GALLERY_MODAL_IMAGE_COUNT);
    this.galleryModal.$imageList.append(this.galleryTemplate(ids));
  }

  galleryTemplate(ids) {
    let galleryImagesHtml = '';
    ids.forEach(id => {
      if (id) {
        const image = this.model.getImageData(id);
        galleryImagesHtml += `<li data-id='${id}'><img alt='${
          image.alt
        }' src='${image.galleryUrl}'/></li>`;
      }
    });
    return galleryImagesHtml;
  }

  // helpfulButton

  getHelpfulClass() {
    return this.HELPFUL_ACTIVE_CLASSES;
  }

  getHelpfulState(id) {
    return this.model.getImageData(id).helpfulState;
  }

  getHelpfulAction(id) {
    return this.model.getImageData(id).helpfulState === HELPFUL
      ? NOT_HELPFUL
      : HELPFUL;
  }

  onHelpfulButtonClick(event) {
    if (!this.model.isLoggedIn()) {
      this.redirectToLogin('helpful', event);
      return;
    }

    const imageId = this.$modal.attr('data-active-id');
    const imageData = this.model.getImageData(imageId);
    const action = this.getHelpfulAction(imageId);

    trackingHubAdd('UgcPhotosHelpfulClick', {
      ugc_image_id: imageId,
      ugc_image_url: imageData.url,
    });

    return this.helpfulFetchHandler.send({
      action,
      imageId,
    });
  }

  onHelpfulSuccess({ id }) {
    const action = this.getHelpfulAction(id);
    this.setHelpfulState(id, action);
    this.setHelpfulCount(id, action);
  }

  setHelpfulState(id, action) {
    this.model.updateImageData(id, { helpfulState: action });
  }

  setHelpfulCount(id, action) {
    const image = this.model.getImageData(id);

    let count;
    switch (action) {
      case HELPFUL:
        count = image.helpfulCount + 1;
        break;
      case NOT_HELPFUL:
        count = image.helpfulCount - 1;
        break;
      default:
        count = image.helpfulCount;
    }

    this.model.updateImageData(id, { helpfulCount: count });
    return count;
  }

  setHelpfulButtonViewState(arg) {
    const id = typeof arg === 'object' ? arg.id : arg;
    const action = this.getHelpfulState(id);

    switch (action) {
      case HELPFUL:
        return this._setHelpfulButtonView(id);
      case NOT_HELPFUL:
        return this._setNotHelpfulButtonView(id);
      default:
        return this._setNotHelpfulButtonView(id);
    }
  }
}

UgcPhotosAbstract.HELPFUL = HELPFUL;
UgcPhotosAbstract.NOT_HELPFUL = NOT_HELPFUL;

module.exports = UgcPhotosAbstract;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/UgcPhotosAbstract.js